import { keepPreviousData, useQuery } from "@tanstack/react-query";

/** All report queries share the "gavion-report" prefix so live refresh can invalidate them together. */
export const REPORT_QUERY_PREFIX = "gavion-report";
export const useReport = <T>(
  key: readonly unknown[],
  fn: () => Promise<T>,
  options: {
    enabled?: boolean;
    /** GAVION team sessions: polling for what realtime does not carry (a session starting, pausing, ending). */
    refetchInterval?:
      | number
      | false
      | ((data: T | undefined) => number | false);
  } = {},
) => {
  const every = options.refetchInterval;
  return useQuery({
    queryKey: [REPORT_QUERY_PREFIX, ...key],
    queryFn: fn,
    enabled: options.enabled ?? true,
    retry: false,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    refetchInterval:
      typeof every === "function"
        ? (query) => every(query.state.data as T | undefined)
        : (every ?? false),
  });
};
